import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function MobileIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.94088 13.125C10.129 13.125 10.2812 12.9719 10.2812 12.7846V1.2145C10.2812 1.02725 10.129 0.875 9.94088 0.875H4.05912C3.871 0.875 3.71875 1.02725 3.71875 1.2145V12.7846C3.71875 12.9719 3.871 13.125 4.05912 13.125H9.94088ZM4.05913 0H9.94088C10.6111 0 11.1562 0.545125 11.1562 1.2145V12.7846C11.1562 13.4549 10.6111 14 9.94088 14H4.05913C3.38888 14 2.84375 13.4549 2.84375 12.7846V1.2145C2.84375 0.545125 3.38888 0 4.05913 0ZM6.36562 11.6925C6.36562 11.3425 6.65 11.0582 7 11.0582C7.35 11.0582 7.63438 11.3425 7.63438 11.6925C7.63438 12.0434 7.35 12.3278 7 12.3278C6.65 12.3278 6.36562 12.0434 6.36562 11.6925Z'
      />
    </svg>
  );
}
